import {
GET_PAYMENT_REMINDER,
GET_PAYMENT_REMINDER_SUCCESS,
GET_PAYMENT_REMINDER_ERROR,
DELETE_PAYMENT_REMINDER,
DELETE_PAYMENT_REMINDER_SUCCESS,
DELETE_PAYMENT_REMINDER_ERROR,
UPDATE_PAYMENT_REMINDER,
UPDATE_PAYMENT_REMINDER_SUCCESS,
UPDATE_PAYMENT_REMINDER_ERROR,
TOOGLE_PAYMENT_REMINDER,
TOOGLE_PAYMENT_REMINDER_SUCCESS,
TOOGLE_PAYMENT_REMINDER_ERROR
  } from "../actions/payReminder.js";

  const initialState = {
    isLoading: false,
    getPaymentReminderSucces: {},
    getPaymentReminderError: undefined,
    updatePaymentReminderSucces:{},
    updatePaymentReminderError:undefined,
    togglePaymentReminderSucces:{},
    togglePaymentReminderError:undefined,
    deletePaymentReminderSucces:{},
    deletePaymentReminderError:undefined,
    CodeError: '',
  };
  
  export default (
    state = initialState,
    {
      type,
      getPaymentReminderSucces,
      getPaymentReminderError,
      updatePaymentReminderSucces,
      updatePaymentReminderError,
      togglePaymentReminderSucces,
      togglePaymentReminderError,
      deletePaymentReminderSucces,
      deletePaymentReminderError,
      CodeError,
    }
  ) => {
    switch (type) {
      case GET_PAYMENT_REMINDER:
        
        return {
          ...state,
          isLoading: true,
        };
      case GET_PAYMENT_REMINDER_SUCCESS:
        return {
          ...state,
          getPaymentReminderSucces,
          isLoading: false,
          getPaymentReminderError: undefined,
        };
      case GET_PAYMENT_REMINDER_ERROR:
        return {
          ...state,
          getPaymentReminderError,
          isLoading: false,
          CodeError:'',
          getPaymentReminderSuccess: {},
        };
        case UPDATE_PAYMENT_REMINDER:
        
        return {
          ...state,
          isLoading: true,
        };
      case UPDATE_PAYMENT_REMINDER_SUCCESS:
        return {
          ...state,
          updatePaymentReminderSucces,
          isLoading: false,
          updatePaymentReminderError: undefined,
        };
      case UPDATE_PAYMENT_REMINDER_ERROR:
        return {
          ...state,
          updatePaymentReminderError,
          isLoading: false,
          CodeError:'CP0521',
          updatePaymentReminderSucces: {},
        };
        case TOOGLE_PAYMENT_REMINDER:
        
        return {
          ...state,
          isLoading: true,
        };
      case TOOGLE_PAYMENT_REMINDER_SUCCESS:
        return {
          ...state,
          togglePaymentReminderSucces,
          isLoading: false,
          togglePaymentReminderError: undefined,
        };
      case TOOGLE_PAYMENT_REMINDER_ERROR:
        return {
          ...state,
          togglePaymentReminderError,
          isLoading: false,
          CodeError:'',
          togglePaymentReminderSucces: {},
        };
        case DELETE_PAYMENT_REMINDER:
        
        return {
          ...state,
          isLoading: true,
        };
      case DELETE_PAYMENT_REMINDER_SUCCESS:
        return {
          ...state,
          deletePaymentReminderSucces,
          isLoading: false,
          deletePaymentReminderError: undefined,
        };
      case DELETE_PAYMENT_REMINDER_ERROR:
        return {
          ...state,
          deletePaymentReminderError,
          isLoading: false,
          CodeError:'CP0525',
          deletePaymentReminderSucces: {},
        };
        default:
            return state;
        }
      };